module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card__wrapper"
  }, [_c('div', {
    staticClass: "card__text"
  }, [(_vm.title) ? _c('AppText', {
    attrs: {
      "mod": "no-bottom, small"
    }
  }, [_vm._v("Модуль: "), _c('strong', [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), (_vm.workType) ? _c('AppText', {
    attrs: {
      "mod": "no-bottom, small"
    }
  }, [_vm._v("Профессии: "), _c('strong', [_vm._v(_vm._s(_vm.workType))])]) : _vm._e(), (_vm.competences) ? _c('AppText', {
    attrs: {
      "mod": "no-bottom, small"
    }
  }, [_vm._v("Компетенции: "), _c('strong', [_vm._v(_vm._s(_vm.competences))])]) : _vm._e(), (_vm.educationFormType) ? _c('AppText', {
    attrs: {
      "mod": "no-bottom, small"
    }
  }, [_vm._v("Форма обучения: "), _c('strong', [_vm._v(_vm._s(_vm.educationFormType))])]) : _vm._e(), (_vm.weeks) ? _c('AppText', {
    attrs: {
      "mod": "no-bottom, small"
    }
  }, [_vm._v("Продолжительность: "), _c('strong', [_vm._v(_vm._s(_vm.weeks))])]) : _vm._e(), (_vm.studentCategories) ? _c('AppText', {
    attrs: {
      "mod": "no-bottom, small"
    }
  }, [_vm._v("Категории обучающихся: "), _c('strong', [_vm._v(_vm._s(_vm.studentCategories))])]) : _vm._e(), (_vm.cost) ? _c('AppText', {
    attrs: {
      "mod": "no-bottom, small"
    }
  }, [_vm._v("Стоимость: "), _c('strong', [_vm._v(_vm._s(_vm.cost) + " ₽")])]) : _vm._e()], 1), (!_vm.readonly) ? _c('div', {
    staticClass: "card__buttons"
  }, [_c('Button', {
    on: {
      "click": _vm.removeEmitId
    }
  }, [_vm._v("Исключить модуль из программы")]), _c('router-link', {
    staticClass: "card__link",
    attrs: {
      "to": _vm.linkParam
    }
  }, [_vm._v("Открыть страницу модуля")])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79596cb2","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newprogram/components/cardlist/components/card/Card.vue
// module id = d59db4cd493654eb7ada
// module chunks = 10